import React from 'react';

import { Card, EmptyState, Table } from 'components';
import ProductPlaceholder from 'components/layout/ProductPlaceholder';

import EventThumbnail from '../EventThumbnail';

import thumbnailStyles from '../EventThumbnail/EventThumbnail.module.scss';

const columns = [
  { name: 'Typ' },
  { name: 'Status' },
  { name: 'Serwis' },
  { name: 'Serwisant' },
  { name: 'Telefon' },
  { name: 'Powód' },
  { name: 'Koszt' },
  { name: 'Załączniki' },
  { name: 'Data' }
];

const EventsList = ({ list = [], isLoading, params, refreshCallback }) => {
  if (list.length === 0 && !isLoading) {
    return (
      <Card>
        <EmptyState type={params.keys.search ? 'search' : params.keys.category ? 'search' : 'serviceService'} />
      </Card>
    );
  }

  return (
    <Table
      columns={columns}
      headerClasses={thumbnailStyles.gridRow}
      className={thumbnailStyles.tableWrapper}
    >
      {isLoading ? (
        <ProductPlaceholder />
      ) : (
        list.map((product, i) => (
          <EventThumbnail
            key={`${product.product_id}-${i}`}
            refreshCallback={refreshCallback}
            event={product}
            params={params}
          />
        ))
      )}
    </Table>
  );
};

export default EventsList;
